import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h1>About This Page</h1>
      <p>App to search GitHub Users</p>
      <p>Copyright Ankur</p>
      <p>Version: 1.0.0</p>
    </Fragment>
  );
};

export default About;
